import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Card } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

const ResponseMessage = ({ visible, message, type, onClose }) => {
  const [isVisible, setIsVisible] = useState(visible);

  const iconMap = {
    success: <CheckCircleOutlined style={{ color: "green" }} />,
    error: <CloseCircleOutlined style={{ color: "red" }} />,
    warning: <ExclamationCircleOutlined style={{ color: "orange" }} />,
    info: <InfoCircleOutlined style={{ color: "blue" }} />,
  };

  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 10);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <Card
        style={{
          width: "40vw",
          maxWidth: 600,
          borderColor: type === "error" ? "red" : "gray",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          backgroundColor: "white",
          zIndex: 1001,
          textAlign: "center", // Center the card content
        }}
        title={
          <span
            style={{
              fontSize: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center", // Center the title horizontally
              gap: "10px",
              paddingTop: "17px",
            }}
          >
            {iconMap[type]} {type.toUpperCase()}
          </span>
        }
        headStyle={{ borderBottom: "none" }}
      >
        <p style={{ fontSize: "20px", margin: "0 auto", textAlign: "center" }}>{message}</p>
      </Card>
    </div>
  );
};

const showMessage = (type, props) => {
  const container = document.createElement("div");
  document.body.appendChild(container);
  const root = ReactDOM.createRoot(container);

  const messageProps = typeof props === "string" ? { message: props } : props;

  const handleClose = () => {
    root.unmount();
    document.body.removeChild(container);
  };

  root.render(
    <ResponseMessage
      {...messageProps}
      visible={true}
      type={type}
      onClose={handleClose}
    />
  );
};

ResponseMessage.success = (props) => showMessage("success", props);
ResponseMessage.error = (props) => showMessage("error", props);
ResponseMessage.warning = (props) => showMessage("warning", props);
ResponseMessage.info = (props) => showMessage("info", props);

export default ResponseMessage;